<template>
  <div id="home">
    <div class="container">
      <div class="row">
        <div v-for="gamme in gammes" v-bind:key="gamme.id" class="col-md-6">
          <a :href="gamme.url" class="card">
            <img class="card-img-top" :src="gamme.image" :alt="gamme.title" />
            <div class="card-body">
              <h5 class="card-title">{{ gamme.title }}</h5>
              <p class="card-text">{{ gamme.description }}</p>
              <span class="btn btn-primary">Calculer</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      gammes: [
        {
          id: 1,
          url: "quick-lam-classic",
          title: "Palissade QUICK'LAM classique",
          description:
            "Découvrez la version classic 100% bois de la palissade Quicklam, facile à installer et économique",
          image: "../static/quick-lam-classic.jpg"
        },
        // {
        //   id: 2,
        //   url: "quick-lam-metal",
        //   title: "Palissade QUICK'LAM métal",
        //   description:
        //     "Rajoutez des poteaux métalliques pour plus de style avec la palissade Quicklam Classique Métal",
        //   image: "../static/quick-lam-metal.jpg"
        // },
        {
          id: 3,
          url: "quick-lam-twin",
          title: "Palissade QUICK'LAM twin",
          description:
            "Profitez de la double face lisse et rainurée de la lame Twin dans ce nouveau concept Quicklam",
          image: "../static/quick-lam-twin.jpg"
        },
        // {
        //   id: 4,
        //   url: "quick-lam-twin-metal",
        //   title: "Palissade QUICK'LAM twin métal",
        //   description:
        //     "Le nouveau concept Twin Quicklam rainuré, également disponible avec des poteaux métalliques",
        //   image: "../static/quick-lam-twin-metal.jpg"
        // },
        {
          id: 5,
          url: "quick-lam-venezia",
          title: "Palissade QUICK'LAM venezia",
          description:
            "Pour une palissade contemporaine, optez pour le concept Vénézia et son kit persienne prêt à poser",
          image: "../static/quick-lam-venezia.jpg"
        },
        {
          id: 6,
          url: "quick-lam-double",
          title: "Palissade QUICK'LAM quinconce",
          description:
            "Posez vos lames de bois en quinconce pour donner du relief à votre palissade Quicklam",
          image: "../static/quick-lam-double.jpg"
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.card {
  margin-bottom: 30px;
  color: #000;
  h5 {
    color: #5ead0f;
  }
  &:hover {
    text-decoration: none;
  }
  .btn-primary {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue